import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import SmartLockScheduledCodesForm from './SmartLockScheduledCodesForm';
import styles from './styles';
import { AppState } from '../../redux/store';
import {
  selectSmartLockDetails,
  selectSmartLocksLoading,
  selectSmartLocksRefreshing,
} from '../../redux/selectors/smartLocks';
import {
  updateSmartLockScheduledCodesRequest,
  deleteSmartLockScheduledCodeRequest,
  smartLockDetailsRequest,
  refreshSmartLockDetailsRequest,
} from '../../redux/actions/smartLocks';

const styledComponent = withStyles(styles)(SmartLockScheduledCodesForm);

const mapStateToProps = (state: AppState) => ({
  loading: selectSmartLocksLoading(state),
  refreshing: selectSmartLocksRefreshing(state),
  smartLockDetails: selectSmartLockDetails(state),
});

const mapDispatchToProps = {
  loadSmartLockDetails: smartLockDetailsRequest,
  refreshSmartLockDetails: refreshSmartLockDetailsRequest,
  updateSmartLockScheduledCode: updateSmartLockScheduledCodesRequest,
  deleteSmartLockScheduledCode: deleteSmartLockScheduledCodeRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(styledComponent);
